import { useQuery } from '@tanstack/react-query';
import { commissionsAPI } from '@/shared/lib/api';
import type { CommissionRule } from '@/shared/types';

/**
 * Hook para buscar regras de comissão de um colaborador
 */
export function useCommissionRules(employeeId: string | undefined) {
  return useQuery({
    queryKey: ['commission-rules', employeeId],
    queryFn: async () => {
      if (!employeeId) throw new Error('Employee ID is required');
      const response = await commissionsAPI.getRulesByEmployee(employeeId);
      return response.data.data as CommissionRule[];
    },
    enabled: !!employeeId,
  });
}
